import { invokeApi } from "src/utils";

export const calculate_fine = async () => {
  const requestObj = {
    path: `api/attendance/calculate_fine_by_attendance?month=${new Date().getMonth() + 1}&year=${new Date().getFullYear()}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const getFineList = async (page, rows, data) => {
  const requestObj = {
    path: `api/attendance/get_finesheet?page=${page}&limit=${rows}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const addFine = async (data) => {
  const requestObj = {
    path: `api/attendance/grant_relax_minutes`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const fine_summary = async (page, rows, search, data) => {
  const requestObj = {
    path: `api/payroll/get_payroll_for_deductions?page=${page}&limit=${rows}&search=${search}&employee_id=${
      data?.employee || ""
    }&start_date=${data?.start_date || ""}&end_date=${data?.end_date || ""}${data?.company ? `&company_id=${data?.company?._id || ""}` : ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const paymentConfigration = async (data) => {
  const requestObj = {
    path: `api/attendance/pay_fine`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
